import { styled } from "styled-components";

export const DropContainer = styled.div`
  width: 500px;
  height: 100px;

  border: 2px solid gray;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;
